import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { Parallax } from 'react-scroll-parallax';

import Layout from '../components/Layout'
import SEO from '../components/Seo'
import BackgroundDots from '../components/BackgroundDots'
import HeaderTitle from '../components/HeaderTitle'
import NewsItem from '../components/NewsItem'

const DOTS = [
    {
        mobile: {
            x: -20,
            y: 830,
            position: 'left',
            ellipse: 40,
            circle: 170
        },
        desktop: {
            x: 50,
            y: 970,
            position: 'left',
            ellipse: 83,
            circle: 341
        }
    },
    {
        mobile: {
            x: 0,
            y: 45,
            position: 'right',
            ellipse: 70,
            circle: 220
        },
        desktop: {
            x: 50,
            y: 500,
            position: 'right',
            ellipse: 140,
            circle: 440
        }
    }
]

export const List = styled.ul`
    width: 100%;
`

class News extends React.Component {

    render() {
        return (
            <Layout theme='dark'>

                <SEO title='News' />
                <HeaderTitle label='News' />
                
                <List>
                    {this.props.allPrismicNews.nodes.map((item, index) => {
                        return <NewsItem key={index} data={item}/>
                    })}
                </List>
                
                <BackgroundDots data={DOTS} />

            </Layout>
        )
    }

}

export default props => (
    <StaticQuery
        query={
            graphql`{
                allPrismicNews(sort: {fields: [data___date], order: DESC}) {
                    nodes {
                        uid
                        data {
                            date(formatString: "DD/MM/YYYY")
                            title {
                                text
                            }
                            content {
                                html
                                text
                            }
                        }
                    }
                }              
            }`
        }
        render={data => <News {...data} {...props} />}
    />
)